export function accessRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ACCESS_START":           
        case "FETCH_ACCESS_START":                                 
        case "UPDATE_ACCESS_START":                                 
        case "DELETE_ACCESS_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_ACCESS_FULFILLED":           
        case "FETCH_ACCESS_FULFILLED":                                 
        case "UPDATE_ACCESS_FULFILLED":                                 
        case "DELETE_ACCESS_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ACCESS_ERROR":
        case "FETCH_ACCESS_ERROR":
        case "UPDATE_ACCESS_ERROR":
        case "DELETE_ACCESS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}